import axios from 'axios'
import * as types from "../mutation-types";

// state
export const state = {
    data: null,
    data_loaded: false,
}

// getters
export const getters = {}

// mutations
export const mutations = {
    [types.GET_INVOICE_ID](state, {invoice}) {
        state.data = invoice[0];
        state.data_loaded = true;
    },
    [types.GET_INVOICE_ID_FAILURE](state, {invoice}) {
        state.invoice = null;
        state.data_loaded = false;
    },
    [types.SET_INVOICE_LOADING_STATE_TRUE](state) {
        state.data_loaded = false;
    },

}

// actions
export const actions = {
    async getInvoice({commit}, id) {
        commit(types.SET_INVOICE_LOADING_STATE_TRUE);
        try {
            const {data} = await axios.post('/api/invoiceId', {
                id: id
            });

            data.forEach(function (element) {
                element.date = new Date(element['ts'] * 1000);
                element.seller_currency = JSON.parse(element['seller']).currency;
                element.seller_label = JSON.parse(element['seller']).label;
                element.seller_address = JSON.parse(element['seller']).address;
                element.seller_phone = JSON.parse(element['seller']).phone;
                element.seller_email = JSON.parse(element['seller']).email;

                element.buyer_label = JSON.parse(element['buyer']).label;
                element.buyer_name = JSON.parse(element['buyer']).name;
                element.buyer_address = JSON.parse(element['buyer']).address;
                element.buyer_phone = JSON.parse(element['buyer']).phone;
                element.buyer_email = JSON.parse(element['buyer']).email;
            });
            // console.log(data)

            commit(types.GET_INVOICE_ID, {invoice: data})
        } catch (e) {
            commit(types.GET_INVOICE_ID_FAILURE)
        }
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/invoiceId.js